<div>
	<div class="title">
		<span>Instructions</span>
		<img class="close-button" src="/assets/img/close.svg" (click)="onClose.emit()" />
	</div>
	@if (activity && activityText) {
		<div class="body">
			<app-language-tabs
				[activity]="activity"
				[selectedLanguage]="activityText.default_lang_id"
				(onTabChange)="onLanguageChange($event)"
			></app-language-tabs>
			<div class="long-description" [innerHTML]="activityText.description_html || 'N/A'"></div>
		</div>
	}
</div>
